export default "<router-outlet></router-outlet>\n<!-- <app-navbar></app-navbar>\n<app-dashboard></app-dashboard> -->\n"